/**
 * Shared copy for “supported formats” (Drive bottom bar, upload errors, etc.).
 */
export function SupportedFormatsContent() {
  return (
    <>
      <p className="mb-0">
        <span className="text-brand-neutral-600">Documents:</span>
        <span> PDF, Word, Powerpoint, Text, Markdown</span>
      </p>
      <p className="mb-0">
        <span className="text-brand-neutral-600">Spreadsheets:</span>
        <span> Excel, CSV</span>
      </p>
      <p className="mb-0">
        <span className="text-brand-neutral-600">Data:</span>
        <span> JSON, HTML, XML</span>
      </p>
    </>
  )
}
